import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
export default function SubtitleSeparator({ children, size = 'base', className, primary = false }) {
    return (_jsxs("div", { className: `flex items-center justify-center gap-4 self-stretch ${className}`, children: [_jsx("div", { className: "border-stroke-base-medium border-offset-[-0.50px] h-0 flex-1 border" }), _jsx("div", { className: classNames('justify-start font-normal', {
                    'text-heading': primary,
                    'text-body': !primary,
                    'text-base leading-6': size === 'base',
                    'text-sm leading-6': size === 'sm',
                }), children: children }), _jsx("div", { className: "border-stroke-base-medium border-offset-[-0.50px] h-0 flex-1 border" })] }));
}
